import { render, staticRenderFns } from "./StockModification.vue?vue&type=template&id=6cd18576&"
import script from "./StockModification.vue?vue&type=script&lang=ts&"
export * from "./StockModification.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports